import BenefitLinkCard from './BenefitLinkCard'
export default BenefitLinkCard
